if (!customElements.get('product-discount')) {
  class ProductDiscount extends HTMLElement {
    constructor() {
      super();

      this.handleChange = this.handleChange.bind(this);
      this.handleVariantChange = this.handleVariantChange.bind(this);
    }

    handleVariantChange(event) {
      if (!event.detail.price) return;

      this.variantPrice = event.detail.price;
    }

    handleChange(event) {
      if (event.target.name != 'quantity') return;
      const quantity = Number(event.target.value ?? 1);

      if (quantity < this.quantity)
        return document.dispatchEvent(
          new CustomEvent('update:price', {
            detail: { price: this.variantPrice, isDiscounted: false, quantity },
          }),
        );

      const rawPrice = ((100 - this.percentage) * this.variantPrice) / 100;
      const decimalPlaces = (this.variantPrice.toString().split('.')[1] || '')
        .length;
      const price = parseFloat(rawPrice.toFixed(decimalPlaces));

      document.dispatchEvent(
        new CustomEvent('update:price', {
          detail: { price, isDiscounted: true, quantity },
        }),
      );
    }

    disconnectedCallback() {
      this.form.removeEventListener('change', this.handleChange);
      document.removeEventListener('variant:change', this.handleVariantChange);
    }

    connectedCallback() {
      this.variantPrice = this.getAttribute('js-variant-price');
      this.quantity = this.getAttribute('js-discount-quantity');
      this.percentage = this.getAttribute('js-discount-percentage');
      this.form = this.closest('form');

      if (!this.form || !this.variantPrice || !this.quantity) return;

      this.form.addEventListener('change', this.handleChange);
      document.addEventListener('variant:change', this.handleVariantChange);
    }
  }

  customElements.define('product-discount', ProductDiscount);
}
